module.exports = __webpack_public_path__ + "img/piedefault.ee9ace3a.png";